"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Truck: function() {
        return Truck;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Truck = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 6C1 4.34315 2.34315 3 4 3H12C13.6569 3 15 4.34315 15 6V7H18.5C18.7884 7 19.0627 7.12448 19.2526 7.3415L22.7494 11.3379C22.9054 11.5142 23 11.7461 23 12V18C23 18.5523 22.5523 19 22 19H20.8293C20.4175 20.1652 19.3062 21 18 21C16.6938 21 15.5825 20.1652 15.1707 19H14H8.32929C7.91746 20.1652 6.80622 21 5.5 21C4.19378 21 3.08254 20.1652 2.67071 19H2C1.44772 19 1 18.5523 1 18V13V6ZM3 14V16.3411C3.53746 15.5328 4.45651 15 5.5 15C6.80622 15 7.91746 15.8348 8.32929 17H13V14H3ZM13 12H3V6C3 5.44772 3.44772 5 4 5H12C12.5523 5 13 5.44772 13 6V8V12ZM15 14V17H15.1707C15.5825 15.8348 16.6938 15 18 15C19.3062 15 20.4175 15.8348 20.8293 17H21V14H15ZM19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18ZM15 12V9H18.0462L20.6712 12H15ZM5.5 17C4.94772 17 4.5 17.4477 4.5 18C4.5 18.5523 4.94772 19 5.5 19C6.05228 19 6.5 18.5523 6.5 18C6.5 17.4477 6.05228 17 5.5 17Z",
        fill: "currentColor"
    })
}), "Truck");
const _default = Truck;
